import { render, staticRenderFns } from "./shopreport.vue?vue&type=template&id=837cc30c&scoped=true&"
import script from "./shopreport.vue?vue&type=script&lang=js&"
export * from "./shopreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837cc30c",
  null
  
)

export default component.exports